const floatingElement = document.getElementById("floating");
const targetElement = document.getElementById("free-counseling");

function updateFloatingVisibility() {
  const targetRect = targetElement.getBoundingClientRect();
  const targetTopPosition = targetRect.top;
  const currentScrollPosition = window.scrollY;
  const targetOffsetPosition = targetTopPosition + currentScrollPosition;
  const viewportHeight = window.innerHeight;

  if (currentScrollPosition > targetOffsetPosition - viewportHeight) {
    floatingElement.classList.add("is-hide");
  } else {
    floatingElement.classList.remove("is-hide");
  }
}

window.addEventListener("DOMContentLoaded", () => {
  if (!floatingElement || !targetElement) {
    return;
  }

  window.addEventListener("scroll", updateFloatingVisibility);
});
